<template>
<svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M2.25787 0.673772L7.03084 5.44674C7.32373 5.73964 7.32373 6.21451 7.03084 6.5074L2.25787 11.2804C1.96498 11.5733 1.4901 11.5733 1.19721 11.2804C0.904317 10.9875 0.904317 10.5126 1.19721 10.2197L5.43985 5.97707L1.19721 1.73443C0.904316 1.44154 0.904316 0.966665 1.19721 0.673772C1.4901 0.380878 1.96498 0.380878 2.25787 0.673772Z" fill="white"/>
</svg>
</template>
  
<script>
export default {
  name: "CollapseArrow",
};
</script>